const filterListModalFilterService = {
  filter: 'FILTERS',
  clear: 'clean filters'
};

export default filterListModalFilterService;
